<div class="section">
    <div class="nova__label">Willing to License</div>
    <div data-qa-id="an_rjd_willingtolicense_value">
        <label *ngIf="locumsJobAdditionalDetails?.isWillingToLicense === null" data-qa-id="an_rjd_willingtolicense_dash">-</label>
        <label *ngIf="locumsJobAdditionalDetails?.isWillingToLicense !== null" data-qa-id="an_rjd_willingtolicense_hasvalue">  
            {{ locumsJobAdditionalDetails?.isWillingToLicense | boolean }}
        </label>
    </div>
</div>
